var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnexosRecomendacion',{attrs:{"oDataAnexos":_vm.oData,"bCargandoInformacion":_vm.bCargando},model:{value:(_vm.bModal),callback:function ($$v) {_vm.bModal=$$v},expression:"bModal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }